export type { TVCardContent } from './private/vCardContentState'
export { vCardContentAtom } from './private/vCardContentState'
